import { Search } from 'lucide-react';

import { Button } from '@shigo-ui/ui';

import { dashboardT } from '../../lib/messages';
import { openCommandPalette } from './commandPaletteStore';

export function CommandPaletteTrigger() {
  const placeholder = dashboardT('search.placeholder');
  const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform);

  return (
    <Button
      aria-label={placeholder}
      className="text-muted-foreground h-9 w-auto max-w-sm min-w-0 justify-start gap-2 px-3 text-sm font-normal xl:w-64"
      onClick={openCommandPalette}
      variant="outline"
    >
      <Search aria-hidden="true" className="h-4 w-4 shrink-0" />
      <span className="truncate">{placeholder}</span>
      <kbd className="bg-muted text-muted-foreground ml-auto hidden shrink-0 rounded border px-1.5 py-0.5 text-[10px] font-medium sm:inline-flex">
        {isMac ? '⌘ K' : 'Ctrl K'}
      </kbd>
    </Button>
  );
}
